import { nuxtLeadsRepository } from '~~/adapters/repositories/nuxt/nuxtLeadsRepository';

export interface LeadData {
	name: string;
	phone: string;
	email?: string;
	message?: string;
}

export interface PropertyLeadData extends LeadData {
	propertyId: string;
	adCampaign?: Record<string, string>;
}

export interface CondoLeadData extends LeadData {
	condoId: string;
	condoName: string;
	companyDistribution: string;
	adCampaign?: Record<string, string>;
}

export interface LeadSubmissionResult {
	success: boolean;
	error?: string;
}

export function useLeadService() {
	const logger = useLogger('LeadService');

	async function createPropertyLead(
		data: PropertyLeadData
	): Promise<LeadSubmissionResult> {
		try {
			const [_, error] = await nuxtLeadsRepository.createPropertyLead({
				comments: data.message || '',
				propertyId: data.propertyId,
				email: data.email || null,
				name: data.name,
				phoneNumber: data.phone,
				...(data.adCampaign || {})
			});

			if (error) {
				return {
					success: false,
					error: error || 'Erro ao criar lead de imóvel'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao criar lead de imóvel', {
				propertyId: data.propertyId,
				name: data.name,
				phone: data.phone,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao criar lead de imóvel'
			};
		}
	}

	async function createCondoLead(
		data: CondoLeadData
	): Promise<LeadSubmissionResult> {
		try {
			const [_, error] = await nuxtLeadsRepository.createCondoLead({
				comments: data.message || '',
				canonicalCondoId: data.condoId,
				companyDistribution: data.companyDistribution,
				canonicalCondoName: data.condoName,
				email: data.email || null,
				name: data.name,
				phoneNumber: data.phone,
				...(data.adCampaign || {})
			});

			if (error) {
				return {
					success: false,
					error: error || 'Erro ao criar lead de condomínio'
				};
			}

			return { success: true };
		} catch (error) {
			logger.error('Erro inesperado ao criar lead de condomínio', {
				condoId: data.condoId,
				condoName: data.condoName,
				name: data.name,
				phone: data.phone,
				error
			});
			return {
				success: false,
				error: 'Erro inesperado ao criar lead de condomínio'
			};
		}
	}

	return {
		createPropertyLead,
		createCondoLead
	};
}
